import React, {useEffect, useState} from "react";
import styles from './styles.module.scss';

const Countdown = (props   ) => {
    const [countdownDate, setCountdownDate] = useState(props.date);
    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        setInterval(() => setNewTime(), 1000);
    }, []);

    const setNewTime = () => {
        if (countdownDate) {
            const currentTime = new Date().getTime();

            const distanceToDate = countdownDate - currentTime;

            let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
            let hours = Math.floor(
                (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            );
            let minutes = Math.floor(
                (distanceToDate % (1000 * 60 * 60)) / (1000 * 60),
            );
            let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

            const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

            days = `${days}`;
            if (numbersToAddZeroTo.includes(hours)) {
                hours = `0${hours}`;
            } else if (numbersToAddZeroTo.includes(minutes)) {
                minutes = `0${minutes}`;
            } else if (numbersToAddZeroTo.includes(seconds)) {
                seconds = `0${seconds}`;
            }

            setState({ days: days, hours: hours, minutes, seconds });
        }
    };

    return (
        <div className={`${styles.countdownContainer}`}>
            <h2><small>{window.scs_countdown_title ? window.scs_countdown_title: 'Offer Ends in'}:</small></h2>
            <div className={`${styles.countdownWrapper}`}>
                <div className={`${styles.timeSection}`}>
                    <div className={`${styles.time}`}>{state.days || '0'}</div>
                    <small className={`${styles.timeText}`}>Days</small>
                </div>
                <div className='time-section'>
                    <div className={`${styles.time}`}>:</div>
                </div>
                <div className='time-section'>
                    <div className={`${styles.time}`}>{state.hours || '00'}</div>
                    <small className={`${styles.timeText}`}>Hours</small>
                </div>
                <div className='time-section'>
                    <div className={`${styles.time}`}>:</div>
                </div>
                <div className='time-section'>
                    <div className={`${styles.time}`}>{state.minutes || '00'}</div>
                    <small className={`${styles.timeText}`}>Minutes</small>
                </div>
                <div className='time-section'>
                    <div className={`${styles.time}`}>:</div>
                </div>
                <div className='time-section'>
                    <div className={`${styles.time}`}>{state.seconds || '00'}</div>
                    <small className={`${styles.timeText}`}>Seconds</small>
                </div>
            </div>
        </div>
    );
};

export default Countdown;
